import { KEY_RECOIL } from '@/shared/config';

type Registry<T> = Record<string, T>;

// On-demand debug snapshot (mirrors `logmeta`): registers `window[globalName]()` to console.table a
// keyed registry, and returns the writer callers push into instead of logging inline.
const createDevLog = <T>(globalName: string, seed: Registry<T> = {}) => {
  const registry: Registry<T> = { ...seed };
  const snapshot = () => {
    console.table(registry);
    return registry;
  };
  if (typeof window !== 'undefined') {
    (window as unknown as Record<string, typeof snapshot>)[globalName] = snapshot;
  }
  return (key: string, value: T) => {
    registry[key] = value;
  };
};

type TabStatus = {
  isActiveTab: boolean;
  isStartedAiProcessing: boolean;
  hasCallStart: boolean;
};

const REPORT_TABS = [
  KEY_RECOIL.BEAT_HR,
  KEY_RECOIL.HR_SUMMARY,
  KEY_RECOIL.RHYTHM_EVENT,
  KEY_RECOIL.STRIP_MANAGEMENT,
];

export const reportTabStatus = createDevLog<TabStatus>(
  'logtabstatus',
  Object.fromEntries(
    REPORT_TABS.map((tab) => [
      tab,
      { isActiveTab: false, isStartedAiProcessing: false, hasCallStart: false },
    ]),
  ),
);

type SocketAckOutcome = 'ok' | 'error' | 'timeout';

type SocketAckRecord = {
  outcome: SocketAckOutcome;
  id: string;
  detail?: unknown;
  at: string;
};

const writeSocketAck = createDevLog<SocketAckRecord>('logsocketack');

export const reportSocketAck = (
  status: string,
  outcome: SocketAckOutcome,
  id: string,
  detail?: unknown,
) => writeSocketAck(status, { outcome, id, detail, at: new Date().toISOString() });
